import AiLogo from 'assets/images/ai.svg?react';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';
import './LangflowHeader.scss';
import { IconButton } from '@mui/material';
import { Dispatch } from 'react';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import dayjs from 'dayjs';
import { useLangflowChatContext } from '../../contexts/LangflowChat.context';

interface LangflowHeaderProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setIsHistoryOpen: Dispatch<React.SetStateAction<boolean>>;
}

export const LangflowHeader = ({ isOpen, setIsOpen, setIsHistoryOpen }: LangflowHeaderProps) => {
  const { t } = useTranslation();
  const { selectedSessionId, chats, setSelectedSessionId, isHistorySession, setIsHistorySession } =
    useLangflowChatContext();

  const foundChat = chats.find((chat) => chat.sessionId === selectedSessionId);

  const selectedChatTitle =
    foundChat &&
    `${t('chat:chat_history.session')} ${dayjs(foundChat.lastMessageDate).format(
      'MMM DD, HH:mm:ss',
    )}`;

  const shouldRenderDefaultHeading = selectedSessionId && isHistorySession;

  return (
    <div className="langflow-chat-header">
      <div className="langflow-chat-header-left">
        {shouldRenderDefaultHeading ? (
          <>
            <span className="langflow-chat-selected-chat-title">{selectedChatTitle}</span>
            <IconButton
              className="langflow-chat-icon-btn"
              disableRipple
              onClick={() => {
                setIsHistoryOpen(true);
              }}
            >
              <KeyboardArrowDownRoundedIcon />
            </IconButton>
          </>
        ) : (
          <>
            <AiLogo className="langflow-chat-logo" />
            <h2 className="langflow-chat-title">{t('chat:title')}</h2>
            <span className="langflow-chat-beta">{t('chat:beta')}</span>
          </>
        )}
      </div>
      <div className="langflow-chat-header-right">
        {!shouldRenderDefaultHeading && (
          <IconButton
            onClick={() => setIsHistoryOpen((prev) => !prev)}
            disableRipple
            className="langflow-chat-icon-btn"
          >
            <AccessTimeIcon className="langflow-chat-clock-icon" />
          </IconButton>
        )}
        {shouldRenderDefaultHeading && (
          <IconButton
            className="langflow-chat-icon-btn"
            disableRipple
            onClick={() => {
              setSelectedSessionId('');
              setIsHistorySession(false);
            }}
          >
            <ChatOutlinedIcon className="langflow-history-start-chat-icon" />
          </IconButton>
        )}
        <IconButton
          onClick={() => setIsOpen(!isOpen)}
          disableRipple
          className="langflow-chat-icon-btn"
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};
